import { List, Map } from 'immutable';
import { DEFAULT_SESSION_ID } from '../constants';
import { practiceListActions } from './actions';
import { PracticeList } from './practice-list';

export const initialState = new Map({
  currentPracticeListId: DEFAULT_SESSION_ID,
  [DEFAULT_SESSION_ID]: new PracticeList({id: DEFAULT_SESSION_ID, isNew: false})
});

export function practiceListsReducer(state = initialState, action) {

  const { type, payload } = action;
  switch (type) {
    case practiceListActions.FETCH_PRACTICES_SUCCESS:
    case practiceListActions.FETCH_PRACTICES_PENDING:
      let practiceListId = (typeof(payload.practiceListId) === 'string' ? payload.practiceListId : state.get('currentPracticeListId'))
      return state.set(
        practiceListId,
        practiceListReducer(state.get(practiceListId), action)
      );
    case practiceListActions.LOAD_PRACTICES:
      return state.merge({
        currentPracticeListId: payload.practiceListId,
        [payload.practiceListId]: practiceListReducer(state.get(payload.practiceListId), action)
      });
    case practiceListActions.REJECT_PRACTICE:
      return state.merge({
        [state.get('currentPracticeListId')]: practiceListReducer(state.get(state.get('currentPracticeListId')), action)
      });
    default:
      return state;
  }
}

export const practiceListReducer = (state = new PracticeList() , { payload, type }  ) => {
  switch (type) {
    case practiceListActions.FETCH_PRACTICES_SUCCESS:
     return state.withMutations(practiceList => {
      Array.isArray(payload.data) ?
      practiceList
        .merge({
          isNew:false,
          isPending:false,
          total: payload.total ? payload.total : state.total,
          practiceIds: mergeIds(practiceList.practiceIds, payload.data)
       })
       :
       practiceList
        .merge({
          isNew:false,
          isPending:false
       })

      });
    case practiceListActions.FETCH_PRACTICES_PENDING:
      return state.set('isPending', true);
    case practiceListActions.LOAD_PRACTICES:
      return state.withMutations(practiceList => {
        practiceList
          .merge({
            id: payload.practiceListId,
            filters: payload.filters,
          });
        });
    default:
      return state;
  }
}

function mergeIds(practiceIds, items) {
  let ids = practiceIds.toJS();

  let newIds = items.reduce((list, practiceData) => {
    if (ids.indexOf(practiceData.id) === -1) list.push(practiceData.id);
    return list;
  }, []);

  return newIds.length ? new List(ids.concat(newIds)) : practiceIds;
}
